import addproduct from 'Backend/Firestore/upload'
import validateproduct from 'Backend/Firestore/validate'
import upload2 from 'Backend/Storage/upload2'
import errormessage from 'components/Main/error'
import React from 'react'
import Swal from 'sweetalert2'

export default function Accessories() {
    const css = `
  .form-control{
        width: 99%;
    }
    body{
        overflow-x: hidden;
    }
    input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
  `
  function Back() {
    Swal.fire({
      title: 'Are you sure?',
      text: "Are you sure that you want to go back?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, go back!'
    }).then((result) => {
      if (result.isConfirmed) {
        history.back()
      }
    })
  }
    function Add(){
        if(document.getElementById("Model_Name").value === ""){
          errormessage("Please Enter Model Name")
        }else if(document.getElementById("Accessories_Picture").value === ""){
          errormessage("Please Upload Picture")
        }else{
          validateproduct('Accessories',document.getElementById("Model_Name").value,()=>{
            upload2("Accessories",document.getElementById("Model_Name").value,document.getElementById("Accessories_Picture").files[0],(url)=>{
              addproduct(document.getElementById('Available').value,"Accessories",{
                  Model_Name:document.getElementById("Model_Name").value,
                  Image:url
              });
          })
          })

        }
    }
  return (
    <>
    <style>{css}</style>
      <center><h1>Add Accessories</h1></center>
      <div className="row" style={{width:'80%',marginLeft: '10%'}}>
        <div className="col-sm-12">
        <label htmlFor="Model_Name" className="form-label" style={{fontWeight: "bold"}}>Model Name</label>
                <input type="text" id="Model_Name" data-name="Model_Name" required className="form-control"/>
                <label htmlFor="Available" className="form-label" style={{fontWeight: "bold"}}>Available</label>
                    <select id="Available" className="form-control">
                        <option defaultValue="Yes">Yes</option>
                        <option defaultValue="No">No</option>
                    </select>
                <label htmlFor="Accessories_Picture" className="form-label" style={{fontWeight: "bold"}}>Accessories Picture</label>
                <input type="file" id="Accessories_Picture" data-name="Accessories_Picture" accept="image/*" className="form-control"/>
                <br/>
                <div className='row'>
                <div className='col-sm-12' style={{display: 'flex',justifyContent: 'center',alignItems: 'center'}}>
                <button className="btn btn-primary" type="button" style={{marginRight: '10px'}} onClick={()=>{Add()}}>Save</button>
                <button className="btn btn-danger" type="button" onClick={()=>{Back()}}>Back to Products</button>
                </div>
                </div>
        </div>
      </div>
    </>
  )
}
